import React from 'react';
import styles from './Section.module.css';

// LP 内の共通セクションラッパー。黒基調で固定（dark/light 非依存）。
export default function Section({
  id,
  title,
  eyebrow,
  background = '',
  children,
  className = '',
  containerClassName = 'mx-auto w-full max-w-3xl',
}) {
  return (
    <section
      id={id}
      className={`relative ${background} px-6 py-16 sm:py-20 ${className}`.trim()}
    >
      <div className={containerClassName}>
        {title && (
          <header className={styles.header}>
            {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
            <h2 className={styles.title}>
              {title}
              <span className={styles.titleLine} />
            </h2>
          </header>
        )}
        {children}
      </div>
    </section>
  );
}
